import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { DERegulatoryErrorCode, VerificationErrorCode } from '../../../types/status';
import RMFExtraVerificationTransition from '../../RMF/components/RMFExtraVerificationTransition/RMFExtraVerificationTransition';
import ValidationUnsuccessful from '../ValidationUnsuccessful/ValidationUnsuccessful';
import VerificationExhausted from '../VerificationExhausted/VerificationExhausted';
import VerificationFailed from '../VerificationFailed/VerificationFailed';

import SphonicVerificationError from './components/SphonicVerificationError';

interface Props {
  onClose(): void;
  code: string;
}

const ElectronicVerificationErrors: React.FC<Props> = ({ onClose, code }) => {
  const siteId = useSelector(select.cms.getSiteId);
  const isUk = siteId === Sites.UK;
  const isDe = siteId === Sites.DE;
  const isFrance = siteId === Sites.FRA;
  const isPt = siteId === Sites.POR;
  const isCAON = siteId === Sites.CA_ON;
  const isUS = useSelector(select.cms.isSiteUS);
  const isRetryScreenEnabled = useFeature(FeatureFlag.SwcRetryScreen);

  switch (true) {
    case isDe &&
      !isRetryScreenEnabled &&
      code === VerificationErrorCode.ElectronicVerificationFailed:
    case isDe && code === DERegulatoryErrorCode.SERVICE_NOT_AVAILABLE:
    case isDe && code === VerificationErrorCode.ElectronicVerificationFailedTooManyRequests:
      return <SphonicVerificationError onClose={onClose} code={code as string} />;
    case isUS && code === VerificationErrorCode.FiscalCodeLen9Required:
    case isUS && code === VerificationErrorCode.ElectronicVerificationFailed:
    case isUS && code === VerificationErrorCode.ElectronicVerificationFailedTooManyRequests:
      return <RMFExtraVerificationTransition onClose={onClose} />;
    case isUk && code === VerificationErrorCode.ElectronicVerificationFailed:
    case isUk && code === VerificationErrorCode.ElectronicVerificationFailedTooManyRequests:
      return null;
    case (isFrance || isDe) &&
      isRetryScreenEnabled &&
      code === VerificationErrorCode.ElectronicVerificationFailed:
      return null;
    case isCAON &&
      [
        VerificationErrorCode.ElectronicVerificationFailed.toString(),
        VerificationErrorCode.ElectronicVerificationFailedTooManyRequests.toString()
      ].includes(code) &&
      isRetryScreenEnabled:
      return null;
    case code === VerificationErrorCode.ElectronicVerificationFailed:
      return <VerificationFailed onClose={onClose} />;
    case isPt && code === VerificationErrorCode.ElectronicVerificationFailedTooManyRequests:
      return <ValidationUnsuccessful onClose={onClose} />;
    case code === VerificationErrorCode.ElectronicVerificationFailedTooManyRequests:
      return <VerificationExhausted onClose={onClose} />;
    default:
      return null;
  }
};

export default ElectronicVerificationErrors;
